import Component from '@glimmer/component';
import { action } from '@ember/object';
import { service } from '@ember/service';

export default class archiveModalComponent extends Component {
  @service router;

  // This needs a rewrite after cleanup.
  @action
  closeModal() {
    if (this.router.currentURL.includes('teams')) {
      this.router.transitionTo(
        'operations.teams.team.check-in',
        this.args.model.parent_id,
      );
      return;
    }
    if (this.router.currentURL.includes('workstreams')) {
      this.router.transitionTo(
        'backlog.initiatives.initiative.workstreams',
        this.args.model.parent_id,
      );
      return;
    }
    // if (this.router.currentURL.includes('planning')) {
    //   this.router.transitionTo('backlog.initiatives.initiative.planning', this.args.model.parent_id);
    //   return;
    // }
  }
}
